/* PastéBCN — Collection banner
   Web Component <pb-collection-banner> con IntersectionObserver para
   animar la entrada (fade + translateY con stagger). Respeta reduced-motion. */

if (!customElements.get('pb-collection-banner')) {
  class PbCollectionBanner extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this._observer.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }
  }

  customElements.define('pb-collection-banner', PbCollectionBanner);
}
